import React from 'react';
import Sidebar from '../../components/layout/Sidebar/Sidebar';
import './Settings.css';

const SettingsPage = () => {
    return (
        <div className="settings-page-container">
            <Sidebar />
            <main className="main-content">
                <div className="settings-top-row">
                    <div className="settings-title-block">
                        <h1>Settings</h1>
                        <p>Manage your account settings and application preferences.</p>
                    </div>
                </div>

                <div className="settings-content-wrapper">
                    <div className="settings-card card-box">
                        <h2>Profile Settings</h2>
                        <p className="placeholder-text">Profile management features are coming soon. For now, your account acts as a Super Admin with all permissions enabled.</p>
                    </div>

                    <div className="settings-card card-box">
                        <h2>Notifications</h2>
                        <p className="placeholder-text">Global notification settings will be available in a future update.</p>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default SettingsPage;
